import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Box, Button, Typography, Paper } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function PalletDetailScreen() {
  const { id } = useParams();

  return (
    <ScreenFrame
      title={`Pallet ${id}`}
      actions={<Button component={Link} to="/prototype/pallets" variant="outlined" size="small">Back to list</Button>}
    >
      <Paper sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">Location</Typography><Typography>A-1</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Raw material</Typography><Typography>Mix KOOI 1</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Lot</Typography><Typography>L2401260</Typography>
      </Paper>
      <Box sx={{ mt: 2 }}>
        <Button component={Link} to="/prototype/incoming-deliveries/1" variant="outlined" size="small">View delivery</Button>
      </Box>
    </ScreenFrame>
  );
}
